import * as React from "react";
export function SvgSpacesMediumExternalServer(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      id="Spaces_Medium_External_Server_svg__Layer_1"
      x={0}
      y={0}
      width={24}
      height={24}
      xmlSpace="preserve"
      {...props}
    >
      <style>{".Spaces_Medium_External_Server_svg__st0{fill:#676767}"}</style>
      <path
        id="Spaces_Medium_External_Server_svg__Line3_3_"
        className="Spaces_Medium_External_Server_svg__st0"
        d="M16 15h2v1h-2z"
      />
      <path
        id="Spaces_Medium_External_Server_svg__Line2_3_"
        className="Spaces_Medium_External_Server_svg__st0"
        d="M16 10h2v1h-2z"
      />
      <path
        id="Spaces_Medium_External_Server_svg__Line1_3_"
        className="Spaces_Medium_External_Server_svg__st0"
        d="M18 5h-2v1h2z"
      />
      <path
        id="Spaces_Medium_External_Server_svg__ServerOutline_2_"
        className="Spaces_Medium_External_Server_svg__st0"
        d="M20 4c0-.6-.4-1-1-1H4c-.6 0-1 .4-1 1v4c0 .2.1.4.2.5-.1.1-.2.3-.2.5v4c0 .2.1.4.2.5-.1.1-.2.3-.2.5v4c0 .6.4 1 1 1h15c.6 0 1-.4 1-1v-4c0-.2-.1-.4-.2-.5.1-.1.2-.3.2-.5V9c0-.2-.1-.4-.2-.5.1-.1.2-.3.2-.5V4zM4 4h15v4H4V4zm15 9H4V9h15v4zm0 5H4v-4h15v4z"
      />
    </svg>
  );
}
